import { render, staticRenderFns } from "./StepVerification.vue?vue&type=template&id=10ca1646&scoped=true"
import script from "./StepVerification.vue?vue&type=script&lang=js"
export * from "./StepVerification.vue?vue&type=script&lang=js"
import style0 from "./StepVerification.vue?vue&type=style&index=0&id=10ca1646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ca1646",
  null
  
)

export default component.exports